/**
 * Internal/test tenant IDs to exclude from conversations
 * and analytics when the "Hide internal tenants" toggle is on.
 *
 * To update this list, add or remove tenant IDs below.
 */
export const EXCLUDED_TENANT_IDS: string[] = [
  "63a48912-49ae-4f94-88f0-23524f6131b5", // Harmony IT
  "eb582130-9a36-43ef-9058-313af36f672b", // Harmony Trial
  "1c8d74e8-0ea0-4b13-ab86-fda9bdfc82b1", // Demo
  "6367618c-be2a-4856-aaaa-9521edabfbef", // MaorTest
  "6d4a1865-5d2b-4227-817b-4cd00ebce022", // Nir Logo Test
  "10096de4-c019-41e5-9060-a6fb820af984", // Slack
  "cc5f45ba-e0c5-4db7-a9e5-9d62de32a015", // alon-test
  "361ec55b-4fbb-45e0-8115-1b42ba3b9355", // org-alpha
  "45f1377c-baf6-4cd7-bc35-40fc4f035bbb", // rantest
  "1c4f91d0-ac46-43b7-a225-0d9fde1d3e81", // subdomain bug1
  "3a41e1fe-eef8-495d-ae9e-234c4b915117", // tal-test
  "dc26105e-ab68-43ee-92b1-5fbb99be0124", // Synthetic-Monitor
  "238ba406-3453-476e-ad3b-6b48ac6c24ef", // Cyera Test
  "9e33a6ab-c65d-480d-b02b-89035bd5890f", // jsm-test-2
  "e330853b-9fc6-4b69-a328-e5b663265823", // ophir-test
  "e64d781b-d2b8-477f-b209-6c25bea9c817", // Ben Tibi Testing
  "a9ce34bb-2e00-40c7-b01a-a2aa7d98ddd9", // Ben Tibi Okta Testing
  "e3d883b2-e627-47b7-9bb9-3398a2ba8dd0", // Harmony Internal
  // eu-main
  "d86f7e40-6843-4c40-aab6-d9a947a34e5c", // Harmony IT (EU)
  "339e8037-e03a-4278-8f1c-60d3b0bfe3ec", // EU Test Tenant
  "4745bae8-3de5-4d32-a92c-6c8fe7eace43", // Synthetic-Monitor (synmon-eu)
];
